import { Fragment } from 'react';

import { LegalDisclaimer } from '@playbooks/components/auth/legal-disclaimer';
import { GithubAuthBtn } from '@playbooks/components/github/github-auth-btn';
import { GoogleAuthBtn } from '@playbooks/components/google/google-auth-btn';
import { Feedback } from '@playbooks/molecules/feedbacks';
import { Button } from '@playbooks/ui/components/button';
import { DialogFooter, DialogHeader, DialogTitle } from '@playbooks/ui/components/dialog';
import { Separator } from '@playbooks/ui/components/separator';

const AuthFlowWelcome = ({ open, setOpen, onClose, onView, onNext }) => {
	// Render
	return (
		<Fragment>
			<DialogHeader>
				<DialogTitle>Get Started</DialogTitle>
			</DialogHeader>
			<div>
				<Feedback
					layout='modal'
					icon='hand-wave'
					title='Welcome to Playbooks!'
					text={`Explore premium software projects, partials and themes built by your peers to jumpstart your next project.`}
				/>
			</div>
			<DialogFooter className='block space-y-4'>
				<GoogleAuthBtn onNext={onNext} />
				<GithubAuthBtn variant='outline' onNext={onNext} />
				<div className='flex-middle gap-3 text-xs text-foreground-subtle'>
					<Separator />
					<span>or</span>
					<Separator />
				</div>
				<Button variant='outline' size='lg' onClick={() => onView('login')} className='w-full'>
					Log in with email
				</Button>
				<Button variant='outline' size='lg' onClick={() => onView('register')} className='w-full'>
					Register with email
				</Button>
				<LegalDisclaimer />
			</DialogFooter>
		</Fragment>
	);
};

export { AuthFlowWelcome };
